<script>
import logo from '@/assets/logo-sm.png';

export default {
  data() {
    return {
      logo,
      drawer: false,
      isAuthenticated: false,
    };
  },
  watch: {
    $route() {
      // console.log('*** HeaderNav >> the route changed ***', this.$route.path);
      this.checkAuthStatus();
    }
  },
  computed: {
    // isAuthenticated() {
    //   return this.$store.getters['isAuthenticated'];
    // },
    viewingDashboard() {
      return this.$route.path.includes(`/dash`);
    },
    todaysDateDisplay() {
      return this.$store.getters['todaysDateDisplay'];
    },
    dayOfWeek() {
      return this.$store.getters['dayOfWeek'];
    },
  },
  methods: {
    async signOut() {
      this.$router.push('/signout');
    },
    checkAuthStatus() {
      const u = localStorage.getItem('uId');
      const t = localStorage.getItem('idToken');
      this.isAuthenticated = u && t;
    },
    clickedHeaderNavLogo() {
      window.location.href = this.isAuthenticated ? '/' : '/dash';
    },
  },
  mounted() {
    this.checkAuthStatus();
    // console.log('*** HeaderNav MOUNTED ***');
  },
}
</script>

<template>
  <v-app-bar class="my-app-bar" fixed height="42">
    <v-app-bar-title>
      <img @click.prevent="clickedHeaderNavLogo" :src="logo" alt="" height="42" class="mt-2" />
    </v-app-bar-title>

    <v-spacer></v-spacer>

    <span v-if="viewingDashboard && dayOfWeek && todaysDateDisplay"
        class="text-h5 font-weight-bold"
    >
      <u>{{ dayOfWeek }}, {{ todaysDateDisplay }}</u>
    </span>

    <!-- HAMBURGER ICON -->
    <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
  </v-app-bar>



  <!-- NAV ITEMS -->
  <v-navigation-drawer v-model="drawer"
                       temporary location="right"
  >

    <v-list nav v-if="isAuthenticated">
      <v-list-item>
        <router-link to="/dash">Dashboard</router-link>
      </v-list-item>
      <v-list-item>
        <router-link to="/mindmovie">MindMovie</router-link>
      </v-list-item>
      <v-list-item>
        <router-link to="/workouts">WorkoutLog</router-link>
      </v-list-item>
      <v-list-item>
        <router-link to="/whatdo">whatDo?</router-link>
      </v-list-item>

      <div class="header-nav-spacer">&nbsp;</div>

      <v-list-item>
        <router-link to="/spankbank">SpankBank</router-link>
      </v-list-item>
      <v-list-item>
        <router-link to="/cheatmeal">CheatMeal</router-link>
      </v-list-item>

      <div class="header-nav-spacer">&nbsp;</div>

      <v-list-item>
        <router-link to="/wrp/all">WRP</router-link>
      </v-list-item>
      <v-list-item>
        <router-link to="/menus">MenuMaker2000</router-link>
      </v-list-item>

      <div class="header-nav-spacer">&nbsp;</div>

      <v-list-item>
        <router-link to="/faq">FAQs</router-link>
      </v-list-item>
      <v-list-item>
        <router-link to="/account">My Account</router-link>
      </v-list-item>
      <v-list-item>
        <router-link to="/" @click.prevent="signOut" class="text-red-darken-2">Sign Out</router-link>
      </v-list-item>
    </v-list>


    <!-- !isAuthenticated -->
    <v-list v-else>
      <v-list-item>
        <router-link to="/faq">FAQs</router-link>
      </v-list-item>
      <v-list-item>
        <router-link to="/about">About</router-link>
      </v-list-item>
      <v-list-item>
<!--        <router-link to="/contact">Contact</router-link>-->
        <router-link to="/faq#contact-form">Contact</router-link>
      </v-list-item>
<!--      <v-list-item>-->
<!--        <router-link to="/signup">Sign Up</router-link>-->
<!--      </v-list-item>-->
      <v-list-item>
        <router-link to="/">Login</router-link>
      </v-list-item>
    </v-list>


  </v-navigation-drawer>

</template>

<style lang="scss" scoped>
a {
  color: black;
  text-decoration: none;
  font-weight: bold;
}
.v-list-item {
  text-align: right;
  min-height: 52px;
}
img:hover { cursor: pointer;}
.header-nav-spacer {
  height: 52px;
}
</style>
